"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventAggregationRule = void 0;
/**
 * The rule how to aggregate the value of an event (if any given) with
 * subsequent calls.
 *
 * @type {{Avg: string, Sum: string}}
 */
var EventAggregationRule;
(function (EventAggregationRule) {
    /**
     * Just add any new value given.
     */
    EventAggregationRule["Sum"] = "sum";
    /**
     * Calculate the average of the given values.
     */
    EventAggregationRule["Avg"] = "avg";
})(EventAggregationRule || (EventAggregationRule = {}));
exports.EventAggregationRule = EventAggregationRule;
